import html2canvas from "html2canvas";
import pdfMake from "pdfmake/build/pdfmake";

export const waitForNextPaint = () =>
  new Promise((resolve) =>
    requestAnimationFrame(() => requestAnimationFrame(resolve))
  );

const DEFAULT_PAGE_MARGINS = [0, 40, 0, 0];

export const createPdfFromHtml = async ({
  fileName,
  element,
  contentWidth,
  pageMargins = DEFAULT_PAGE_MARGINS,
  scale,
}) => {
  const nodes = (element ?? [document.getElementById("print")]).filter(Boolean);
  if (!nodes.length) throw new Error("createPdfFromHtml: nothing to render");

  const content = [];
  for (const node of nodes) {
    // eslint-disable-next-line no-await-in-loop
    const canvas = await html2canvas(node, scale ? { scale } : undefined);
    const image = canvas.toDataURL("image/png");
    const width = contentWidth ?? canvas.width * 0.3;
    canvas.width = 0;
    canvas.height = 0;
    content.push({
      image,
      width,
      ...(content.length ? { pageBreak: "before" } : {}),
    });
  }

  const pdfProps = {
    pageSize: "A4",
    pageOrientation: "portrait",
    content,
    pageMargins,
    defaultStyle: {
      alignment: "center",
    },
  };

  pdfMake.createPdf(pdfProps).download(`${fileName}.pdf`);
};
